
<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     行业下游
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="prm-industry padding-footer">
    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item sm">
          <f-search-input v-model="query.keyword" width="160" placeholder="名称" prefix-icon="el-icon-search" clearable @change="fetchData(1)" />
        </div>
      </div>
      <div class="toolbox">
        <f-sort-selector v-model="query.sortby" :options="sortOptions" class="ml" @change="sortChange" />
      </div>
    </div>
    <el-card v-loading="loading" shadow="never" class="card mb-md">
      <el-table ref="listTable" :data="list" tooltip-effect="dark">
        <el-table-column type="index" width="50" label="#" />
        <el-table-column width="60">
          <div class="customer-icon text-blue radius5" slot-scope="scope">
            <div class="iconfont icon-customer"></div>
          </div>
        </el-table-column>

        <el-table-column label="客户" min-width="220">
          <div slot-scope="scope" class="company-box">
            <div class="mb-xs">{{ scope.row.short_name }}</div>
            <div class="text-muted font-sm">{{ scope.row.full_name }}</div>
          </div>
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" label="设备数量" min-width="160" align="center">
          <template slot-scope="scope">
            <span class="font-lg text-black">{{ scope.row.equip_count }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="60" />
        <el-table-column :show-overflow-tooltip="true" label="创建日期" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.createtime | parseTime('{y}/{m}/{d}') }}</span>
          </template>
        </el-table-column>

        <template slot="append">
          <div class="foot-menu" :class="!collapse && 'active'">
            <f-table-footer>
              <template slot="right">
                <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
              </template>
            </f-table-footer>
          </div>
        </template>

        <div v-if="!loading" slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt class="no-data" />
          </div>
        </div>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { getIndustryListApi } from "@/api/prm/prmIndustryApi"

export default {
  name: "PrmIndustry",

  components: {
  },

  data() {
    return {
      sortOptions: [
        { value: 1, title: "最近创建" },
        { value: 2, title: "最早创建" },
        { value: 3, title: "最多设备" }
      ],
      loading: false,
      total: 0,
      query: {
        sortby: +localStorage.getItem('__PRM_INDUSTRY_SORT__') || 1,
        keyword: '',
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
      },
      list: [],
    }
  },
  
  created() {
    this.fetchData(1)
  },

  computed: {
    collapse() {
      return this.$store.state.commonStore.collapse;
    },
  },

  methods: {
    fetchData(page) {
      if (page) {
        this.query.pindex = page
      }
      this.loading = true
      getIndustryListApi(this.query).then(res => {
        this.loading = false
        if (!res.errno) {
          this.list = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    sortChange(val) {
      this.query.sortby = val.value
      localStorage.setItem('__PRM_INDUSTRY_SORT__', val.value)
      this.fetchData(1)
    }
  },
}
</script>

<style scoped lang="scss">
.prm-industry {
  padding-bottom: 70px;

  .customer-icon {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 40px;
    background-color: #F3F4F6;
  }

  .company-box {
    line-height: 1;
  }

  .foot-menu {
    position: fixed;
    background-color: #fff;
    bottom: 0;
    left: 240px;
    width: calc(100% - 240px);
    z-index: 3;
    padding-left: 20px;
    padding: 4px 30px 5px 20px;

    &.active {
      left: 340px;
      width: calc(100% - 340px);
    }

    .f-table-footer {
      margin: 0;
      height: 50px;
    }
  }
}
</style>
